import { MouseEvent, useCallback, useState } from "react";

import { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn, themeColors } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { useUserBusiness } from "@tudigo-monorepo/tudigo-session";
import { ButtonRebrand, Icon } from "@tudigo-monorepo/web-tudigo-components";

import { NotifyProjectModal } from "./notify-project-modal";
import { useProjectNotificationsSubscription } from "./use-project-notifications-subscription";

export function ProjectNotify(props: { project: Project; className?: string }) {
  const { project } = props;

  const { user } = useUserBusiness();
  const { t } = useTranslation();

  const { isSubscribed, isLoading, subscribeProject, unsubscribeProject } =
    useProjectNotificationsSubscription(project.id);

  const [showNotifyModal, setShowNotifyModal] = useState(false);

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      if (isSubscribed) {
        return unsubscribeProject(project);
      }

      if (user) {
        subscribeProject(user.email, project);
      } else {
        setShowNotifyModal(true);
      }
    },
    [isSubscribed, user, unsubscribeProject, subscribeProject, project],
  );

  const handleVisitorConfirmSubscription = (email: string) => {
    subscribeProject(email, project);
    setShowNotifyModal(false);
  };

  return (
    <>
      {showNotifyModal && (
        <NotifyProjectModal
          isOpen
          project={project}
          onConfirm={handleVisitorConfirmSubscription}
          onClose={() => setShowNotifyModal(false)}
        />
      )}

      <ButtonRebrand
        variant="primary"
        size="default"
        onClick={handleClick}
        className={cn("bg-primary-500 gap-x-2.5 font-normal", props.className)}
      >
        <Icon
          name={isLoading ? "Loading" : "Notification"}
          primaryColor={themeColors[isSubscribed ? "primary-rebrand" : "white"]}
          size="XS"
        />
        {isSubscribed
          ? t("component.project_card.footer.no_longer_notified")
          : t("component.project_card.footer.be_notified_of_launch")}
      </ButtonRebrand>
    </>
  );
}
